const transformValues = <T extends Record<string, any>>(
  data: T,
  transformFn: (key: string, value: any) => [string, any]
): T => Object.fromEntries(Object.entries(data).map(([key, value]) => transformFn(key, value))) as T

export const changeNullsToEmptyString = <T extends Record<string, any>>(data: T): T =>
  transformValues(data, (key, value) => [key, value === null ? '' : value])

export const changeEmptyStringsToNull = <T extends Record<string, any>>(data: T): T =>
  transformValues(data, (key, value) => [key, value === '' ? null : value])